// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"8b4f36f8","531":"d382b7fa","553":"d382b7fa"}[chunkId] + ".chunk.css";
};